import type {AddComponentTypeOptions} from 'grapesjs';
import {FORM_LABEL_STYLES} from '@FormMakerReact/components/component-styles';

export const POSTERMYWALL_LABEL_TYPE = 'postermywall-label';
const FORM_LABEL_DATA_ATTR = 'data-is-pmw-form-label';

export const POSTERMYWALL_LABEL: AddComponentTypeOptions = {
  isComponent: (el: HTMLElement) => {
    if (typeof el.getAttribute !== 'function') {
      return undefined;
    }
    return el.tagName === 'LABEL' && el.getAttribute(FORM_LABEL_DATA_ATTR) !== null ? {type: POSTERMYWALL_LABEL_TYPE} : undefined;
  },
  model: {
    defaults: {
      tagName: 'label',
      highlightable: false,
      hoverable: false,
      selectable: false,
      draggable: false,
      badgable: false,
      copyable: false,
      editable: false,
      toolbar: [],
      content: 'Email*',
      attributes: {
        'data-pmw-type': POSTERMYWALL_LABEL_TYPE,
        [FORM_LABEL_DATA_ATTR]: '1',
      },
      style: FORM_LABEL_STYLES,
    },
  },
};
